export const MODE_SLIDE = 'slide';
export const MODE_SYMBOL = 'symbol';
export const MODE_TEMPLATE = 'template';

export const MODES = [MODE_SLIDE, MODE_SYMBOL, MODE_TEMPLATE];
